import { Logo } from "components";
import { useEffect, useRef, useState } from "react";

export default function Loading() {
  const intervalRef = useRef<NodeJS.Timer | null>(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    clearInterval(intervalRef.current ?? undefined);
    intervalRef.current = setInterval(() => {
      setProgress((p) => p + Math.random() * 20);
    }, 500);
    return () => {
      clearInterval(intervalRef.current ?? undefined);
    };
  }, []);
  return (
    <section className="w-full min-h-[100svh] flex flex-col bg-[#f4f8fb]">
      <div className="w-full m-auto flex flex-col items-center text-center py-10 px-5">
        <Logo className="w-40" variant="logo-text-col" />
        <div className="w-full h-2 max-w-64 bg-[#acafbd] rounded-full mt-10 mx-auto">
          <div
            style={{ width: `${progress}%` }}
            className="max-w-[95%] h-full bg-[#3E97FF] rounded-full transition-[width]"
          />
        </div>
      </div>
    </section>
  );
}
